import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setSavedLinkClick,
  getSavedCoupons,
  fetchSavedDrugs
} from '../../actions/userDrug';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { SAVE_DRUG_TITLE, SAVE_DRUG_DESC } from '../../constants/defaults';
import SkipTo from '../common/Tag/SkipTo';
import SearchBar from '../SearchBar/index.jsx';
import MainSaveDrugsList from './SaveDrugsList';
import MainSaveCouponsList from './SaveCouponsList';
import Loader from '../common/Loader';
import '../../stylesheets/pages/saveDrugs.scss';
import { AuthContext } from '../../Contexts';

const MainSaveDrugs = props => {
  const { i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isEs = _.isEqual(i18n.language, 'es');
  const [isLoading, setLoading] = useState(true);
  const [isDrugTab, setIsDrugTab] = useState(false);
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const savedLinkClicked = useSelector(
    state => state.userDrugs.savedLinkClicked
  );
  const onTabChange = (eventName, routeName, drugTab) => {
    _.triggerGTMVirtualPageViewEvent({
      event: eventName
    });
    setIsDrugTab(drugTab);
    history.push(routeName);
  };
  useEffect(() => {
    if (!isLoggedIn) {
      history.push(isEs ? '/es' : '/');
    } else if (
      history.location &&
      history.location.search.includes('drug=true')
    ) {
      setIsDrugTab(true);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      if (!_.isEmpty(localStorage.getItem('saveDrugGTM'))) {
        _.triggerGTMVirtualPageViewEvent({
          event: localStorage.getItem('saveDrugGTM')
        });
        localStorage.removeItem('saveDrugGTM');
      }
    }
    if (isLoggedIn && savedLinkClicked) {
      dispatch(setSavedLinkClick(false));
      dispatch(getSavedCoupons());
      dispatch(fetchSavedDrugs());
    }
  }, []);

  return (
    <main>
      <Helmet>
        <meta
          name="ROBOTS"
          content="NOINDEX, FOLLOW, NOSNIPPET, NOODP, NOYDIR"
        />
        <title>{SAVE_DRUG_TITLE}</title>
        <meta name="description" content={SAVE_DRUG_DESC} />
      </Helmet>
      <div className="mainSaveDrugs">
        <div className="saveDrugsContainer">
          <div className="saveDrugHeader">
            <SkipTo>
              <h1> Saved </h1>
            </SkipTo>
            <div className="saveDrugSearch">
              <SearchBar
                classes="search-container"
                handleZipCodeChange={() => null}
                history={props.history}
                showZipCode={false}
                inputPlaceHolder={
                  isDrugTab ? 'Search to add a drug' : 'Search to add a coupon'
                }
              />
            </div>
          </div>

          <h2 className="textCenter savedDrugHeading">
            Your price may be even lower if bonus savings apply!
          </h2>
          <div className="saveDrugsContent">
            <div className="drugsTabs">
              <ul>
                <li
                  onClick={() =>
                    onTabChange('savedCouponsTab', '/save-drugs', false)
                  }
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      onTabChange('savedCouponsTab', '/save-drugs', false);
                    }
                  }}
                  className={`themeFocus textCenter ${
                    !isDrugTab && 'active gradientPink'
                  }`}
                  tabIndex="0"
                >
                  Coupons
                </li>
                <li
                  onClick={() =>
                    onTabChange('savedDrugsTab', '?drug=true', true)
                  }
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      onTabChange('savedDrugsTab', '?drug=true', true);
                    }
                  }}
                  className={`themeFocus textCenter ${
                    isDrugTab && 'active gradientPink'
                  }`}
                  tabIndex="0"
                >
                  Drugs
                </li>
              </ul>
            </div>
            {isLoading ? (
              <div className="centerBlock">
                <Loader />
              </div>
            ) : isDrugTab ? (
              <MainSaveDrugsList />
            ) : (
              <MainSaveCouponsList />
            )}
          </div>
        </div>
      </div>
    </main>
  );
};
export default MainSaveDrugs;
